import script from "./ResultPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultPopup.vue?vue&type=script&setup=true&lang=js"

import "./ResultPopup.vue?vue&type=style&index=0&id=251e57d4&lang=less"
import "./ResultPopup.vue?vue&type=style&index=1&id=251e57d4&lang=less"

const __exports__ = script;

export default __exports__